import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SiteHeader from './components/site/SiteHeader';
import SiteFooter from './components/site/SiteFooter';
import ScrollRoad from './components/site/ScrollRoad';
import FloatingWidgets from './components/site/FloatingWidgets';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import Rates from './pages/Rates';
import About from './pages/About';
import { PrivacyPolicy, Terms, CookiePolicy } from './pages/Legal';
import Hero from './components/home/Hero';
import AdminDashboard from './components/AdminDashboard';
import DriverDashboard from './components/DriverDashboard';
import Login from './components/Login';
import BookingStatus from './components/BookingStatus';

import AdminDrivers from './components/AdminDrivers';
import AdminCalendar from './components/AdminCalendar';

import DriverCalendar from './components/DriverCalendar';
import './App.css';

// Header, scroll road, footer and floating widgets around every public page.
// On desktop the road stands in for the browser scrollbar (see tailwind.css).
function PublicPage({ children }) {
  useEffect(() => {
    document.documentElement.classList.add('hide-scrollbar');
    return () => document.documentElement.classList.remove('hide-scrollbar');
  }, []);

  return (
    <div className="site-shell">
      <SiteHeader />
      <ScrollRoad />
      {children}
      <SiteFooter />
      <FloatingWidgets />
    </div>
  );
}

// Staff screens are reachable only by direct URL and kept out of search engines.
function StaffPage({ children }) {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return children;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<PublicPage><Home /></PublicPage>} />
          <Route path="/book" element={<PublicPage><main id="main"><Hero /></main></PublicPage>} />
          <Route path="/services" element={<PublicPage><Services /></PublicPage>} />
          <Route path="/about" element={<PublicPage><About /></PublicPage>} />
          <Route path="/rates" element={<PublicPage><Rates /></PublicPage>} />
          <Route path="/status/:id" element={<PublicPage><BookingStatus /></PublicPage>} />
          <Route path="/privacy" element={<PublicPage><PrivacyPolicy /></PublicPage>} />
          <Route path="/terms" element={<PublicPage><Terms /></PublicPage>} />
          <Route path="/cookies" element={<PublicPage><CookiePolicy /></PublicPage>} />

          {/* Staff pages, no public navigation. /login stays for links in driver WhatsApp messages. */}
          <Route path="/admin" element={<StaffPage><Login initialRole="admin" /></StaffPage>} />
          <Route path="/driver" element={<StaffPage><Login initialRole="driver" /></StaffPage>} />
          <Route path="/login" element={<StaffPage><Login /></StaffPage>} />
          <Route path="/admin/dashboard" element={<StaffPage><AdminDashboard /></StaffPage>} />
          <Route path="/admin/drivers" element={<StaffPage><AdminDrivers /></StaffPage>} />
          <Route path="/admin/calendar" element={<StaffPage><AdminCalendar /></StaffPage>} />
          <Route path="/driver/dashboard" element={<StaffPage><DriverDashboard /></StaffPage>} />
          <Route path="/driver/calendar" element={<StaffPage><DriverCalendar /></StaffPage>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
